import { useEffect, useState } from 'react';
import cn from 'classnames';

import { Modal } from 'UIPackage/ModalModule/components/Modal';
import { ViolationStatusesEnum } from 'APIPackage/KnmModule/enums/ViolationStatusesEnum';

import { ModalHeader } from '../../../UIPackage/ModalModule/components/ModalHeader';
import { ModalBody } from '../../../UIPackage/ModalModule/components/ModalBody';
import { ModalActions } from '../../../UIPackage/ModalModule/components/ModalActions';
import { Button } from '../../../UIPackage/MainModule/components/Button';
import styles from './ErknmResultDecisionsViolatedRequirementsModal.module.scss';
import { Row } from '../../../UIPackage/FormModule/components/Row';
import { IKnmErknmFormViolatedRequirementsNpa } from '../../MainModule/interfaces/IKnmErknmFormViolatedRequirementsNpa';

interface IErknmResultDecisionsViolatedRequirementsModalProps {
  requirementsNpa: IKnmErknmFormViolatedRequirementsNpa[] | undefined;
  visible: boolean;
  onClose: () => void;
  onSubmit: (items: IKnmErknmFormViolatedRequirementsNpa[]) => void;
}

export const ErknmResultDecisionsViolatedRequirementsModal = ({
  requirementsNpa,
  visible,
  onClose,
  onSubmit,
}: IErknmResultDecisionsViolatedRequirementsModalProps) => {
  const [selectedRequirements, setSelectedRequirements] = useState<IKnmErknmFormViolatedRequirementsNpa[]>([]);

  useEffect(() => {
    if (visible) setSelectedRequirements([]);
  }, [visible]);

  const isRequirementsNpaEquals = (
    val1: IKnmErknmFormViolatedRequirementsNpa,
    val2: IKnmErknmFormViolatedRequirementsNpa,
  ): boolean => {
    return val1 === val2;
  };

  const isSelected = (requirementNpa: IKnmErknmFormViolatedRequirementsNpa): boolean => {
    return !!selectedRequirements.find(item => isRequirementsNpaEquals(item, requirementNpa));
  };

  const handleSelect = (requirementNpa: IKnmErknmFormViolatedRequirementsNpa) => {
    if (isSelected(requirementNpa)) {
      setSelectedRequirements(selectedRequirements.filter(item => !isRequirementsNpaEquals(item, requirementNpa)));
    } else setSelectedRequirements([...selectedRequirements, requirementNpa]);
  };

  const handleSubmit = () => {
    const selectedRequirementsWithNotFixedViolations = selectedRequirements.map(requirement => ({
      ...requirement,
      violatedMandatory: requirement.violatedMandatory.map(mandatory => ({
        ...mandatory,
        violations:
          mandatory.violations
            ?.filter(violation => violation.status === ViolationStatusesEnum.NOT_FIXED)
            .map(violation => ({ ...violation, isNew: true })) || null,
      })),
      isNew: true,
    }));

    onSubmit(selectedRequirementsWithNotFixedViolations);
    onClose();
  };

  return (
    <Modal visible={visible} onClose={onClose}>
      <ModalHeader title="Выбор выявленного нарушенного обязательного требования" />
      <ModalBody overflow="scroll">
        <Row>
          {`Выберите содержание выявленного нарушенного обязательного требования, которое было устранено и (или) по
          которому было проведено мероприятие по предотвращению причинения вреда (ущерба) охраняемым законом ценностям`}
        </Row>
        {requirementsNpa?.map((requirementNpa, index) => {
          if (!requirementNpa.violatedMandatory || !requirementNpa.violatedMandatory?.length) return null;

          return (
            <div key={index}>
              {requirementNpa.violatedMandatory?.map((mandatory, mandatoryIndex) => {
                if (!mandatory.mandatory || !mandatory.category) return null;

                return (
                  <div key={mandatoryIndex}>
                    <div
                      className={cn(styles.RequirementsItemBlock, {
                        [styles.RequirementsItemBlockSelected]: isSelected(requirementNpa),
                      })}
                      onClick={() => handleSelect(requirementNpa)}
                    >
                      <div className={styles.NpaBlock}>
                        <div className={styles.Header}>
                          <span className={styles.GreyHeader}>Содержание требования</span>
                        </div>
                        {mandatory.mandatory.title}
                      </div>
                      <div className={styles.StructuralUnitBlock}>
                        <div className={styles.Header}>
                          <span className={styles.GreyHeader}>Значимость последствий нарушения</span>
                        </div>
                        {mandatory.category.label}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
        {!requirementsNpa?.length && (
          <div className={styles.EmptyModalText}>
            Для отображения записей выявленных нарушенных обязательных требований необходимо заполнить их в записи
            раздела «Сведения об акте» требуемого контролируемого лица
          </div>
        )}
      </ModalBody>
      <ModalActions>
        <Button
          text="Добавить"
          color="primary"
          size="medium"
          onClick={handleSubmit}
          disabled={!selectedRequirements.length}
        />
        <Button text="Отмена" size="medium" onClick={onClose} />
      </ModalActions>
    </Modal>
  );
};
